import { Component } from '@angular/core';
import { WelcomeCard } from '../../shared/models/card.type';
import { environment } from 'src/environments/environment';
import { welcomeCards } from '../../shared/information-cards';

@Component({
  selector: 'app-early-access',
  templateUrl: './early-access.component.html',
  styleUrls: ['./early-access.component.scss']
})
export class EarlyAccessComponent {
  cards: WelcomeCard[] = welcomeCards;

  learnMoreLink = 'mailto:info@amilearn.ca';

  env = environment;

  currentRoute = '/';
}
